define([
	"dojo/_base/declare",
	"csi/heading/Boolean"
], function(declare,BooleanRen) {

	return declare(BooleanRen, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return boolean indicating if this Agent is default agent
			var	supplier = ctx.view.getViewNode();
			var curNode = ctx.getNode();

			return supplier.Agent == curNode.$URL;
		}
	});
});